import MuiTooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

const LightTooltip = withStyles(theme => ({
  popper: {},
  popperInteractive: {},
  popperArrow: {},
  tooltip: {
    ...theme.typography.h6,
    padding: theme.spacing(0.75, 1),
    backgroundColor: '#E9E9E9', // Not using a theme color because I need to match Antd styling.
    color: '#595959', // Not using a theme color because I need to match Antd styling.
  },
  tooltipArrow: {},
  arrow: {
    color: '#E9E9E9', // Not using a theme color because I need to match Antd styling.
  },
  touch: {},
  tooltipPlacementLeft: {},
  tooltipPlacementRight: {},
  tooltipPlacementTop: {},
  tooltipPlacementBottom: {},
}))(MuiTooltip);

export default LightTooltip;
